import {ModalHeader} from '../ModalHeader';

export const HEADER_HANDLE = `${ModalHeader}`;

const HEADER_BUTTON_CANCEL = `${HEADER_HANDLE} button, ${HEADER_HANDLE} a`;
export const mergeCancelSelectors = (cancel?: string) => {
  return cancel ? `${HEADER_BUTTON_CANCEL}, ${cancel}` : HEADER_BUTTON_CANCEL;
};
